import { render, staticRenderFns } from "./report.vue?vue&type=template&id=99acf4e4&scoped=true&"
import script from "./report.vue?vue&type=script&lang=ts&"
export * from "./report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99acf4e4",
  null
  
)

export default component.exports